import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ element, allowedUsertypes }) => {
  const token = localStorage.getItem('token');
  const usertypeid = localStorage.getItem('usertypeid');
  
  if (!token) {
    return <Navigate to="/adminuser" replace />;
  }

  if (allowedUsertypes && !allowedUsertypes.includes(usertypeid)) {
    return <Navigate to="/" replace />;
  }

  return element;
};

export default ProtectedRoute;
